import { FilteringGuide } from "./filteringGuide";

export class FilterList {
  userId;
  number;
  countryId: Array<number>;
  startingIndex: number;
  pageSize: number = 10;
  standardListType: number;
  IsEquipmentStandard: boolean;
  searchKey: string = "";
  // standardType: number = 0;
  // type: number = null;
  filterSet: FilteringGuide[] = [];
  filter: number[] = [];
  AppliedFilters: any = [];
}
